import { AnyError, WatershedError } from '@watershed/errors/WatershedError';

export class UnitError extends WatershedError {
  // Loosely cribbed from UserInputError, but we can't extend that because our
  // subclasses provide more useful invariant method signatures
  status = 400;
  constructor(message?: string, cause?: AnyError) {
    super('BAD_INPUT', message, { cause });

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, UnitError);
    }
    Object.setPrototypeOf(this, UnitError.prototype);
  }
}
